module.exports={pageTitle:"Luan Raithz Machado",name:"Luan Raithz Machado",themeColor:"#567dbc",socialLinks:[]};